import React, { useEffect } from "react";
import FrontHeader from "../../../../shared/FrontHeader";
import FrontFooter from "../../../../shared/FrontFooter";
import Form from "../../../form/Form";
import Input from "../../../form/Input";
import Textarea from "../../../form/Textarea";
import Button from "../../../form/Button";
import useForm from "../../../../hooks/useForm";
import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setSession } from "../../../../redux/slice/authSlice";
import {
  organizationAddEdit,
  organizationListFront,
} from "../../../../services/organizationService";
import { useParams } from "react-router-dom";
import { setLanguage } from "../../../../redux/slice/languageSlice";
import {
  getOrganizationList,
  setOrganization,
  setOrganizations,
} from "../../../../redux/slice/organizationSlice";

const validation = {
  name: { required: true, message: "Please enter organization name" },
};

const ManageOrganization = () => {
  const dispatch = useDispatch();
  const { session } = useSelector((state) => state?.authProvider);
  const { lang: paramsLang } = useParams();
  const { lang } = useSelector((state) => state?.langProvider);

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({ validationRules: validation });

  useEffect(() => {
    if (paramsLang !== lang) {
      dispatch(setLanguage(paramsLang));
      localStorage.setItem("lang", paramsLang);
    }
  }, [paramsLang, lang]);

  const { mutate: addOrganization, isPending } = useMutation({
    mutationFn: async (value) => {
      return await organizationAddEdit({
        name: { [lang]: value?.name },
        description: { [lang]: value?.description },
        contactEmail: session?.user?.email,
      });
    },
    onSuccess: async (res) => {
      if (res?.status === 200 || res?.status === 201) {
        dispatch(
          setSession({
            ...session,
            user: {
              ...session?.user,
              organization: [
                ...(session?.user?.organization || []),
                res?.data?._id,
              ],
            },
          })
        );
        dispatch(setOrganization(res?.data?._id));
        const org_res = await organizationListFront({ status: "active" });
        if (org_res?.docs?.status === 200) {
          dispatch(setOrganizations(org_res?.docs?.data));
          window.location.href =
            window.location.origin + `/${lang}/user/events`;
        }
      }
    },
  });

  return (
    <div className="min-h-screen flex flex-col">
      <FrontHeader />
      <div className="w-[400px] m-auto py-20">
        <Form handleSubmit={handleSubmit} onSubmit={addOrganization}>
          <Input
            inputName={"name"}
            label={"Organization name"}
            inputPlaceholder={"Enter organization name"}
            value={values?.name}
            onChange={handleChange}
            {...formValidate(errors, "name")}
          />
          <Textarea
            inputName={"description"}
            label={"Description"}
            inputValue={values?.description}
            inputPlaceholder={"Enter description"}
            onChange={handleChange}
          />
          <Button
            buttonType="submit"
            buttonLabel={"Add organization"}
            buttonClasses={"w-full"}
            {...(isPending && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
        </Form>
      </div>
      <FrontFooter />
    </div>
  );
};

export default ManageOrganization;
